import http from '@core/fetch'

export default {
  // 获取用户信息
  userInfo: body =>
    http('/hms/hljMerchantCenter/appApi/user/info/full', {
      body
    }),

  // 获取全部类目
  getPropertyList: body =>
    http('/p/wedding/index.php/Home/APIManagers/propertiesV3', {
      body,
      expect: null
    }),

  // 婚车认证
  enterCarJob: body =>
    http.post('/p/wedding/index.php/Home/APIOaJob/EnterCarJob', { body }),

  // 保存选择品类
  editFromMerchantCenter: body =>
    http.post('/p/wedding/Admin/APIMerchant/editFromMerchantCenter', { body })
}
